var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height pa-0 white", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-col",
            {
              staticClass: "bg-img d-none d-sm-flex align-end white--text",
              attrs: { cols: "8" }
            },
            [
              _c("div", { staticClass: "ma-12 px-10 font-weight-light" }, [
                _c("h1", { staticClass: "display-3" }, [
                  _vm._v(" La Transformación Digital es "),
                  _c("strong", { staticClass: "font-weight-bold" }, [
                    _vm._v("ahora")
                  ])
                ]),
                _c("h3", { staticClass: "font-weight-light" }, [
                  _vm._v(" tecnológica"),
                  _c("strong", { staticClass: "font-weight-bold" }, [
                    _vm._v("gente")
                  ])
                ])
              ])
            ]
          ),
          _c(
            "v-col",
            { staticClass: "px-5", attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "div",
                { staticClass: "px-8 py-md-4 white login-form" },
                [
                  _c("v-img", {
                    staticClass: "ma-20",
                    attrs: {
                      contain: "",
                      src: require("../../assets/daycohost3.png"),
                      alt: "Logo Daycohost",
                      height: "150"
                    }
                  }),
                  _c(
                    "h2",
                    {
                      staticClass:
                        "mt-4 font-weight-light headline text-center",
                      staticStyle: { "font-size": "170% !important" }
                    },
                    [_vm._v(" Recuperación de Contraseña ")]
                  ),
                  _c(
                    "h2",
                    {
                      staticClass: "mt-8 font-weight-light headline text-center"
                    },
                    [_vm._v(" " + _vm._s(_vm.email) + " ")]
                  ),
                  _c(
                    "h2",
                    {
                      staticClass:
                        "mt-8 font-weight-light headline text-center",
                      staticStyle: { "font-size": "90%" }
                    },
                    [_vm._v(" " + _vm._s(_vm.customerName) + " ")]
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _c(
                      "div",
                      { staticClass: "px-8 py-md-4 white login-form" },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form1",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c(
                              "v-text-field",
                              {
                                attrs: {
                                  rules: _vm.PasswordMatchRules,
                                  "append-icon": _vm.showPassword
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.showPassword ? "text" : "password",
                                  autofocus: "",
                                  label: "Nueva contraseña",
                                  "single-line": "",
                                  counter: "",
                                  autocomplete: "off",
                                  maxlength: "30",
                                  required: ""
                                },
                                on: {
                                  "click:append": function($event) {
                                    _vm.showPassword = !_vm.showPassword
                                  },
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.changePassword($event)
                                  }
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password"
                                }
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "prepend-inner" },
                                  [
                                    _c("v-icon", { staticClass: "mr-3" }, [
                                      _vm._v("mdi-account-lock")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              2
                            ),
                            _c(
                              "v-text-field",
                              {
                                attrs: {
                                  "append-icon": _vm.showConfirmationPassword
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.showConfirmationPassword
                                    ? "text"
                                    : "password",
                                  rules: _vm.rules.defaultRules,
                                  disabled:
                                    !_vm.password || _vm.password === " ",
                                  label: "Confirme su nueva contraseña",
                                  "single-line": "",
                                  counter: "",
                                  autocomplete: "off",
                                  maxlength: "30",
                                  required: ""
                                },
                                on: {
                                  "click:append": function($event) {
                                    _vm.showConfirmationPassword = !_vm.showConfirmationPassword
                                  },
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.changePassword($event)
                                  }
                                },
                                model: {
                                  value: _vm.confirmationPassword,
                                  callback: function($$v) {
                                    _vm.confirmationPassword = $$v
                                  },
                                  expression: "confirmationPassword"
                                }
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "prepend-inner" },
                                  [
                                    _c("v-icon", { staticClass: "mr-3" }, [
                                      _vm._v("mdi-account-lock")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              2
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-5",
                                attrs: {
                                  block: "",
                                  dark: "",
                                  color: "rgba(25,58,81,1)",
                                  loading: _vm.loadingForm,
                                  autocomplete: "false"
                                },
                                on: { click: _vm.changePassword }
                              },
                              [_vm._v("Cambiar contraseña")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: _vm.snackbarColor },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: { click: _vm.closeSnackbar }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }